import React, { memo, useCallback } from 'react'

import { Toggle, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import usePrivateModeChange from 'Pods/ThreeDStudio/Hooks/usePrivateModeChange'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import PaidFeatureBadge from 'Pods/ThreeDStudio/Shared/PaidFeatureBadge/PaidFeatureBadge'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setImageAssistantPrivate } from 'Pods/ThreeDStudio/Store/actions/ui'

const TOGGLE_ID = 'composer-private-toggle'
// The row copy stays mounted (measure-only) while the stacked copy shows, so each
// needs its own id for its label to target.
const STACKED_TOGGLE_ID = 'composer-private-toggle-stacked'

const selectIsPrivate = state => state.ui.isImageAssistantPrivate

function PrivateToggle({ isStacked = false }) {
  const t = useTranslation()
  const isPrivate = useThreeDStudioStore(selectIsPrivate)
  const { hasPrivateModeAccess, handlePrivateChange } = usePrivateModeChange(
    'image_private_mode',
    setImageAssistantPrivate,
  )
  const toggleId = isStacked ? STACKED_TOGGLE_ID : TOGGLE_ID

  const handleChange = useCallback(() => handlePrivateChange(!isPrivate), [handlePrivateChange, isPrivate])

  return (
    <div className={classnames('private-toggle', isStacked && 'private-toggle--stacked')}>
      <label htmlFor={toggleId} className="private-toggle__label cgt-button-text-base-semibold">
        {t('imageAssistantPanel.createTab.composer.private')}
      </label>
      <Toggle id={toggleId} isChecked={isPrivate} onChange={handleChange} className="private-toggle__switch" />
      {!hasPrivateModeAccess && (
        <PaidFeatureBadge className="private-toggle__badge" label={t('shared.subscribersOnly.title')} />
      )}
    </div>
  )
}

PrivateToggle.propTypes = {
  isStacked: bool,
}

export default memo(PrivateToggle)
